import { Row } from '@tanstack/react-table';

import Switch from 'components/switch/Switch';
import { Trigger } from 'models/automation/Triggers';
import useStatusCellToggle from './useStatusCellToggle';

interface StatusToggleCellProps {
  getValue: () => Trigger['isActive'];
  row: Row<Trigger>;
}

const StatusToggleCell = ({ getValue, row }: StatusToggleCellProps) => {
  const isActive = getValue();
  const { uid: triggerUid } = row.original;
  const { onChange } = useStatusCellToggle({ triggerUid });

  return <Switch checked={isActive} className="small" onChange={onChange} />;
};

export default StatusToggleCell;
